/**
 * D'où ce bundle est-il servi, et peut-on en déduire où est l'API ?
 *
 * Le SDK déduit l'origine de l'API de l'adresse de sa propre balise : c'est ce
 * qui permet de poser le snippet sans rien configurer, en dev comme en prod.
 * L'hypothèse implicite est que le bundle vient de chez nous.
 *
 * Elle est fausse dès qu'un plugin d'optimisation « rapatrie » les scripts
 * tiers pour les minifier : il sert alors une COPIE du bundle depuis le site
 * du client (constaté le 2026-10-02 avec WP Rocket :
 * `https://exemple.fr/wp-content/cache/min/1/lib/csteer.js`). Le SDK appelait
 * `https://exemple.fr/v1/settings/…`, recevait un 404, et la bannière ne
 * s'affichait jamais — sans la moindre erreur visible pour le visiteur.
 *
 * On ne fait donc confiance à l'origine du script que si elle est l'une des
 * nôtres ; sinon on retombe sur les adresses canoniques. `data-api` reste
 * l'échappatoire explicite et passe avant tout ça.
 */

/** API publique, quand l'origine du script ne permet pas de la déduire. */
export const CANONICAL_API_URL = "https://saas.consenteer.com";

/** Hôte des images et polices du SDK, même cas. */
export const CANONICAL_ASSET_ORIGIN = "https://cdn.consenteer.com";

/**
 * Cet hôte sert-il légitimement le SDK ?
 *
 * Nos domaines, et tout ce qui ne peut être qu'un poste de développement :
 * une copie rapatriée par un plugin vit toujours sur le nom de domaine public
 * d'un client, jamais sur `localhost`, une adresse IP ou un Codespace.
 */
export function isConsenteerHost(hostname: string): boolean {
  const h = hostname.toLowerCase();
  return (
    h === "consenteer.com" ||
    h.endsWith(".consenteer.com") ||
    h === "localhost" ||
    h.endsWith(".localhost") ||
    h.endsWith(".test") ||
    h.endsWith(".app.github.dev") ||
    h === "[::1]" ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(h)
  );
}

let warned = false;

/** Un seul avertissement par page : c'est un indice pour l'intégrateur. */
export function warnSelfHostedCopy(hostname: string): void {
  if (warned) return;
  warned = true;
  console.warn(
    `[csteer] script servi par ${hostname} au lieu de cdn.consenteer.com (copie locale d'un plugin d'optimisation ?). La bannière fonctionne, mais cette copie ne sera plus mise à jour : excluez csteer.js de la minification.`,
  );
}
